const g = require('globals')
const Backbone = require('lib/backbone')
const _ = require('lib/underscore')
const RelatedModel = require('module/user/related_model')
const ProfileUser = require('module/user/profile_user')
const Cart = require('module/user/cart')
const log = require('log').create('signup_user') // eslint-disable-line

// NOTE this model is also used on the homepage

const SignupUser = ProfileUser.extend({

    urlRoot() {
        return `${g.NODE_API}/signup`
    },

    idAttribute: '_id',

    initialize(options) {
        ProfileUser.prototype.initialize.apply(this, arguments)

        // expose cart as top-level property so we can access it directly
        this.cart = new Cart()
    },

})

SignupUser.prototype.relations.push({
    type: Backbone.One,
    key: 'signup',
    relatedModel: RelatedModel.extend({ id: 'signup' }),
})

_.extend(SignupUser.prototype.defaults, {
    'signup': { 'id': 'signup' },
})

module.exports = SignupUser
